module.exports = __webpack_public_path__ + "img/pg5-article-title1-inner.f3a4e9e5.png";